module.exports = __webpack_public_path__ + "img/lock.871042f7.svg";